<div class="tab-container tabs-shadow" [ngClass]="alertvarservice.eventsPanel == 1? 'events-pannel-collapse':''">
    <div class="tab-container-left">
        <ul class="nav nav-tabs">
            <li *ngFor="let tab of tabs; let i = index" (click)="selectTab(tab,i)"
                [ngClass]="clickchange ? 'enable-action':'disable-action'" [class.active]="tab.active">
                <a>{{tab.title}}</a>
            </li>
        </ul>
    </div>
    <div class="tab-container-middle" *ngIf="alertvarservice.factSheetOpened">
        <!-- <div  class="tab-container-right">
            
            <img class="home-icon" [ngClass]="isAction ? 'disable-action':'enable-action'" src="assets/alerts/alert-home.svg" tooltip="Alert home" (click)="close_factsheet()">
        </div> -->
        <div *ngIf="alertvarservice.alertEventsListView" class="factsheet-container-left-bottom-header">
            <!-- <p>Events</p> -->
            <div class="close-events-panel">
                <img class="tooltip-enable" (click)="alertvarservice.closeEventsPanel()" src="assets/alerts/window-min.svg" tooltip="Minimize"
                    alt="" [ngClass]="alertvarservice.eventsPanel == 0 ? 'disable-action-with-opacity':'enable-action'">
                <img class="tooltip-enable" (click)="alertvarservice.collapseEventsPanel()" src="assets/alerts/window-restore.svg"
                    tooltip="Collapse" alt=""
                    [ngClass]="alertvarservice.eventsPanel == 1 ? 'disable-action-with-opacity':'enable-action'">
                <img class="tooltip-enable" (click)="alertvarservice.expandEventsPanel()" src="assets/alerts/window-max.svg" tooltip="Expand"
                    alt="" [ngClass]="alertvarservice.eventsPanel == 2 ? 'disable-action-with-opacity':'enable-action'">
            </div>

        </div>
    </div>
</div>
<ng-content></ng-content>